<script lang="ts" setup>
import { ref } from 'vue';
import { useClaimStore } from '@/store';
import { ClaimsTypes, getDisplayName, ClaimTypeName } from '@/utils/config/constants/claims-types';
import Select from './Select.vue';
import type { ClaimTypeSchema } from '@/interfaces';

const props = defineProps<{ defaultSelection?: ClaimTypeSchema }>();

const claimTypeOptions: Array<{ value: string; label: string; }> = ClaimsTypes.map((claimType) => {
  return {
    value: claimType.name,
    label: getDisplayName(claimType.name as any, { emoji: true }),
  }
});

const selected = ref(
  (props.defaultSelection || ClaimsTypes.find(ct => ct.name === useClaimStore().claim?.claimType?.name))
    || ClaimsTypes[0]);

const selectedOptionIndex = ref(claimTypeOptions.findIndex(ct => ct.value === selected.value?.name) || 0);
</script>
<template>
  <div class="text-left cursor-pointer">
    <Select @update:modelValue="(value) => $emit('update:modelValue', value as any)"
      label="Type de dossier"
      :options="claimTypeOptions"
      :selected-option="selectedOptionIndex"
    />
  </div>
</template>